import BaseMystery from '../BaseMystery'

const FourthLuminousMystery = () => {
	const imagesList = [
		"https://www.wga.hu/art/b/bellini/giovanni/1480-89/100tran.jpg",
		"https://www.wga.hu/art/b/bellini/giovanni/1459/015trans.jpg",
		"https://www.wga.hu/art/a/angelico/09/cells/06_trans.jpg",
		"https://www.wga.hu/art/b/benefial/transfig.jpg",
		"https://www.wga.hu/art/b/botticel/91late/10transf.jpg",
		"https://www.wga.hu/art/d/david/1/transfig.jpg",
		"https://www.wga.hu/art/d/duccio/maesta/predel_v/pre_v_8.jpg",
		"https://www.wga.hu/art/g/genga/transfig.jpg",
		"https://www.wga.hu/art/g/gherardj/cortona1.jpg",
		"https://www.wga.hu/art/g/giordano/1/transfig.jpg",
		"https://www.wga.hu/art/l/lotto/2/07transf.jpg",
		"https://www.wga.hu/art/p/perugino/cambio/6transf.jpg",
		"https://www.wga.hu/art/zgothic/miniatur/1201-250/4other/07_1201.jpg",
		"https://www.wga.hu/art/r/raphael/5roma/5/10trans.jpg",
		"https://www.wga.hu/art/m/master/zunk_y/09icon.jpg",
		"https://www.wga.hu/art/m/master/zunk_x/10icon.jpg",
		"https://www.wga.hu/art/m/master/zunk_x/101icon.jpg",
		"https://www.wga.hu/art/v/veronese/02_1550s/4transfi.jpg",
	];

	const scriptureQuote = "And he was transfigured before them; his face shone like the sun and his clothes became white as light. And behold, Moses and Elijah appeared to them, conversing with him.";
	const scriptureCitation = "Matthew 17:2-3 (NABRE)";
	const citationLink = "https://www.biblegateway.com/passage/?search=Matthew%2017%3A1-9&version=NABRE";

	return (
		<BaseMystery titleText="The Transfiguration"
				imagesList={imagesList}
				scriptureQuote={scriptureQuote}
				scriptureCitation={scriptureCitation}
				citationLink={citationLink}
				rightHanded={true} />
	);
};

export default FourthLuminousMystery;